import dynamic from "@redux-dynostore/react-redux";
import React from "react";
import { connect } from "react-redux";

import FoodDrinkSelector from "../../library/FoodDrinkSelector/FoodDrinkSelector";

import { mapDispatchToProps } from "./FoodDrinkSelector.store";

export const SmartFoodDrinkSelector = (props) => {
  const {
    defaultItems,
    selectedItems,
    setSelectedItems,
    fetchFoodAPI,
    fetchFoodDetailsAPI,
    readOnly,
    inputTitle,
    hasBackground,
    participantLanguage,
    title = "My items",
    showData = true,
  } = props;

  const handleSearch = async (query) => {
    try {
      const results = await fetchFoodAPI(query, participantLanguage);
      return results;
    } catch (error) {
      console.error("Error fetching food items:", error);
      return [];
    }
  };

  const handleSelect = async (item, nixItemId, type, locale) => {
    try {
      const result = await fetchFoodDetailsAPI(item, nixItemId, type, locale);
      if (!result) {
        throw new Error("No data returned from API");
      }
      return result;
    } catch (error) {
      console.error("Error fetching food details:", error.message || error);
      return null;
    }
  };

  return (
    <FoodDrinkSelector
      defaultItems={defaultItems}
      handleSearch={handleSearch}
      handleSelect={handleSelect}
      selectedItems={selectedItems}
      setSelectedItems={setSelectedItems}
      readOnly={readOnly}
      inputTitle={inputTitle}
      title={title}
      hasBackground={hasBackground}
      showData={showData}
    />
  );
};

export default dynamic("smartPageHeaderReducer")(
  connect(null, mapDispatchToProps)(SmartFoodDrinkSelector)
);
